import React from "react";

type FullDetailsProps = {
  data: any;
  title?: string;
  open?: boolean;
};

export function FullDetails({ data, title = "All fields", open = false }: FullDetailsProps) {
  if (data === null || data === undefined) return null;
  return (
    <details className="mt-4 rounded-lg border border-border bg-bg p-3" open={open}>
      <summary className="cursor-pointer text-xs font-semibold uppercase tracking-wide text-muted hover:text-[#4FC3F7]">
        {title}
      </summary>
      <div className="mt-3 space-y-3">
        <FieldBlock label="root" value={data} hideLabel />
      </div>
    </details>
  );
}

function FieldBlock({
  label,
  value,
  hideLabel,
}: {
  label: string;
  value: any;
  hideLabel?: boolean;
}) {
  const isObject = value && typeof value === "object" && !Array.isArray(value);
  const isArray = Array.isArray(value);

  if (isObject) {
    return (
      <details className="rounded-md border border-border bg-surface p-3" open>
        {!hideLabel && (
          <summary className="cursor-pointer text-xs font-semibold uppercase tracking-wide text-muted hover:text-[#4FC3F7]">
            {label}
          </summary>
        )}
        <div className={hideLabel ? "space-y-2" : "mt-3 space-y-2"}>
          {Object.entries(value).map(([k, v]) => (
            <FieldRow key={k} label={k} value={v} />
          ))}
        </div>
      </details>
    );
  }

  if (isArray) {
    return (
      <details className="rounded-md border border-border bg-surface p-3" open>
        {!hideLabel && (
          <summary className="cursor-pointer text-xs font-semibold uppercase tracking-wide text-muted hover:text-[#4FC3F7]">
            {label} <span className="text-muted">({value.length})</span>
          </summary>
        )}
        <div className={hideLabel ? "space-y-2" : "mt-3 space-y-2"}>
          {value.map((item: any, idx: number) => (
            <FieldRow key={idx} label={`#${idx + 1}`} value={item} />
          ))}
        </div>
      </details>
    );
  }

  return (
    <div className="rounded-md border border-border bg-surface px-3 py-2">
      {!hideLabel && <div className="text-xs uppercase tracking-wide text-muted">{label}</div>}
      <div className={hideLabel ? "text-sm" : "mt-1 text-sm"}>{formatScalar(value)}</div>
    </div>
  );
}

function FieldRow({ label, value }: { label: string; value: any }) {
  const isObject = value && typeof value === "object" && !Array.isArray(value);
  const isArray = Array.isArray(value);

  if (isObject || isArray) {
    return <FieldBlock label={label} value={value} />;
  }

  return (
    <div className="grid grid-cols-[140px_1fr] gap-3 rounded-md border border-border bg-bg px-3 py-2">
      <div className="text-xs uppercase tracking-wide text-muted">{label}</div>
      <div className="text-sm break-words">{formatScalar(value)}</div>
    </div>
  );
}

function formatScalar(value: any) {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "true" : "false";
  if (typeof value === "number") return value.toString();
  return String(value);
}
